import { Transform } from 'class-transformer';

import { ImageType } from '@mom/shared/utils';

export class ResearchDetails {
  title: string;
  image: ImageType;
  description: string;
  shortDescription: string;
  targetCompletes: number;
  lengthOfInterview: number;
  incidenceRate: number;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  startDate: Date;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  endDate: Date;
  extReference: string;
  pointsAvailable: number;
  raffleTicketsAvailable: number;
  allowAnoymousInd: boolean;
  allowMultipleInd: boolean;
  prizeDrawEntryActiveInd: boolean;
  prizeDetails: string;
}
